module.exports = __webpack_public_path__ + "static/img/49051.b2c17a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/49051.jpg
// module id = 8hKo
// module chunks = 1